export const generateUid = () => Math.random().toString(36).substring(2, 10);

export const shuffle = <T>(arr: T[]): T[] => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j]!, a[i]!];
  }
  return a;
};

type KeyType = string | number | symbol;

export const ObjectKeys = <T extends Record<KeyType, unknown>>(o: T): (keyof T)[] =>
  Object.keys(o) as (keyof T)[];

export const ObjectValues = <T extends Record<KeyType, unknown>>(o: T): T[keyof T][] =>
  Object.values(o) as T[keyof T][];

export const ObjectEntries = <T extends Record<KeyType, unknown>>(o: T): [keyof T, T[keyof T]][] =>
  Object.entries(o) as [keyof T, T[keyof T]][];
